import React from "react";
import ContentModerationList from "@/components/contentModeration/ContentModerationList";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Activities: list with search, status / date filters and View / Deactivate / Reactivate / Delete.
 */
const ActivitiesModerationList = () => (
  <ContentModerationList sectionKey="activities" />
);

ActivitiesModerationList.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.activities.list,
    pathname: contentModeration.activities.list,
    active: true,
  },
];

export default ActivitiesModerationList;
